export { default } from './SkeletonFareListTwoColumns';
